import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'projects/tools/src/lib/shared/shared.service';
 

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  login_Form!:FormGroup;
  isSubmited:boolean=false;
  loginPathInfo: any;
  conditionArray: any;
  userRole: any;
  title = 'SDM';
  logInUserResponse:any;

  userName="12345"
  pw="123456" 

 userData: any = [
    {
      "username": "CHAdmin",
      "pw": "admin@123",
      "role": "superadmin",
      "rolename": "Super Admin",
      "message": "Super Admin logged in successfully"
    },
    {
      "username": "12507",
      "pw": "Sandeep",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "11893",
      "pw": "Mahesh",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "11001",
      "pw": "Rajashekar",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "12106",
      "pw": "Suman",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "11722",
      "pw": "Saikanth",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "C10599",
      "pw": "Mehraj",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "12825",
      "pw": "Deepika@123",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "12929",
      "pw": "Rama@123",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "12420",
      "pw": "Raj@143",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },
    {
      "username": "admin@healthyrecovery.in",
      "pw": "recovery@123",
      "role": "admin",
      "tenant":"1000267",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },{
      "username": "C11473",
      "pw": "Vikas@123",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    },{
      "username": "C11474",
      "pw": "Dharani@123",
      "role": "admin",
      "rolename": "Admin",
      "message": "Admin logged in successfully"
    }

   
  ]

  constructor(
    private fb:FormBuilder,
    private route:Router,
    private sharedService: SharedService,
    private toastr:ToastrService
  ) {
     if ((localStorage.getItem('userDataRoleBased') !== null && localStorage.getItem('userDataRoleBased') !== '')) {
      this.route.navigate(['/escalations']);
    }

  }

 

  ngOnInit(): void {
    this.login_Form=this.fb.group({
      name:['', Validators.compose([Validators.required,]),],
      password:['', Validators.compose([Validators.required,]),]
    })
  }

 

  get f() {return this.login_Form.controls} 

  login(){
    this.isSubmited =true;

   if (this.login_Form.valid) {
      const user = this.userData.find((user) => user.username === this.login_Form.value.name && user.pw === this.login_Form.value.password);
      console.log(`user`, user);
      if(user){
        this.toastr.success(user.message);
        localStorage.setItem('loginData', JSON.stringify(this.login_Form.value))
        localStorage.setItem('userDataRoleBased', JSON.stringify(user))
        this.logInUserResponse = JSON.parse( localStorage.getItem('userDataRoleBased'));
        localStorage.setItem("actionById", this.logInUserResponse.username);
        localStorage.setItem("actionByName",this.logInUserResponse.username);
        localStorage.setItem("source",this.title);
        localStorage.setItem("role_type",this.logInUserResponse.rolename);
        localStorage.setItem("role", this.logInUserResponse.role);
        this.sharedService.role.next(this.logInUserResponse.role);
        this.route.navigate(['/escalations']);
      }else{
        this.toastr.error('Invalid username or password');
      }
     
    } else  {
      this.toastr.error("Please Enter Valid username and password")
    }

  }

 

  autoSubmit(event:any){
    if(event.which ===13){
       this.login();
    }
  } 

}